const mFeedSectionContentCardDesing3 = {
  mFeedSectionContentCardDesing3: {
    available: 'DISPONIBLE',
    draft: 'BORRADOR',
    hidden: 'Oculto',
    noCategoryName: 'SIN CATEGORÍA',
    noprice: 'SIN PRECIO',
    notAvailable: 'NO DISPONIBLE',

    price: {
      buy: 'COMPRAR',
      free: 'GRATIS'
    },

    published: 'PUBLICADO',
    selected: 'Seleccionada',
    visible: 'Visible'
  }
}

export default mFeedSectionContentCardDesing3
